module.exports = __webpack_public_path__ + "img/banner-about.25943602.jpg";